import { QueryBuilder } from "@cgarciagarcia/react-query-builder";

import { ServiceResponse } from "~/api/api.types";
import {
  AdminBanner,
  Banner,
  BannerListMeta,
  CreateBannerPayload,
  UpdateBannerPayload,
} from "~/api/banner.types";
import { api } from "./axios";

export const fetchActiveBanner = async (): Promise<Banner | null> => {
  const response = await api.get<ServiceResponse<Banner | null>>("/banner");
  return response.data.data;
};

export type BannerListResponse = {
  data: AdminBanner[];
  meta: {
    current_page: number;
    per_page: number;
    last_page: number;
    total: number;
  };
  links: {
    first: string;
    last: string;
    next: string | null;
    prev: string | null;
  };
} & BannerListMeta;

export const listBanners = async ({
  queryBuilder,
}: {
  queryBuilder?: QueryBuilder<Record<string, string> | undefined>;
}): Promise<BannerListResponse> => {
  const response = await api.get<BannerListResponse>(
    `/admin/banners${queryBuilder?.build() ?? ""}`,
  );
  return response.data;
};

export const getBanner = async (id: string): Promise<AdminBanner> => {
  const response = await api.get<ServiceResponse<AdminBanner>>(
    `/admin/banners/${id}`,
  );
  return response.data.data;
};

export const createBanner = async (
  data: CreateBannerPayload,
): Promise<AdminBanner> => {
  const response = await api.post<ServiceResponse<AdminBanner>>(
    "/admin/banners",
    data,
  );
  return response.data.data;
};

export const updateBanner = async (
  id: string,
  data: UpdateBannerPayload,
): Promise<AdminBanner> => {
  const response = await api.patch<ServiceResponse<AdminBanner>>(
    `/admin/banners/${id}`,
    data,
  );
  return response.data.data;
};

export const deleteBanner = async (id: string): Promise<void> => {
  await api.delete(`/admin/banners/${id}`);
};

export const toggleBanner = async (id: string): Promise<AdminBanner> => {
  const response = await api.patch<ServiceResponse<AdminBanner>>(
    `/admin/banners/${id}/toggle`,
  );
  return response.data.data;
};
